var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNetwork3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Statusbar / BTN_Status_Icon_Pos1 / 00_statusbar_network_3_48px_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B_Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-632.000000, -1420.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Statusbar-/-BTN_Status_Icon_Pos1-/-00_statusbar_network_3_48px_white",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network_3",
    transform: "translate(2.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "network_x5F_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,2.5 L44,0 L44,32 L40,32 L40,2.5 Z M30,8.6 L30,32 L34,32 L34,6.1 L30,8.6 Z",
    id: "Shape",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,32 L20,32 L20,14.7 L24,12.2 L24,32 Z M14,18.4 L10,20.9 L10,32 L14,32 L14,18.4 Z M4,24.5 L0,27 L0,32 L4,32 L4,24.5 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetwork3);
export default __webpack_public_path__ + "static/media/icon-network_3.30e48679fdf03837e3f9f33f8a136085.svg";
export { ForwardRef as ReactComponent };